import React from 'react';

export default function Songs() {
  return (
    <>
      <h1 className="wp-portal__page-title">Songs</h1>
      <p className="wp-portal__page-sub">0 songs registered.</p>
      <div className="wp-portal__empty">
        <p className="wp-portal__empty-label">
          No songs found. Your registered compositions and their details
          will appear here once your catalog has been set up.
        </p>
      </div>
    </>
  );
}
